import {gql} from '@apollo/client';

export const QUERY_POSITIONS = gql`
query positions($filters: PositionFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []) {
    positions(filters: $filters, pagination: $pagination, sort: $sort) {
        documentId
        cover {
            documentId
            url
        }
        hit
        new
        pre_order
        name
        volume
        price
        old_price
        aromas {
            documentId
            name
        }
    }
}`

export const QUERY_POSITION = gql`
    query position($documentId: ID!) {
        position(documentId: $documentId) {
            documentId
            cover {
                documentId
                url
            }
            photos {
                documentId
                url
            }
            collections {
                documentId
                name
            }
            article
            hit
            new
            pre_order
            name
            description
            structure
            aroma
            volume
            price
            old_price
            category
            aromas {
                documentId
                name
                description
                group
                notes
            }
        }
    }`

export const QUERY_RECOMEND = gql`
    query recomend($documentId: ID!) {
        recomend(documentId: $documentId) {
            done
        }
    }`